/* Build-time feature flags (VUE_APP_* are baked into the bundle by webpack).
   COMMERCE_ENABLED=false replaces checkout/reservations submit with an
   order-by-email CTA and hides cart/favorites/account entirely. */
export const COMMERCE_ENABLED = process.env.VUE_APP_COMMERCE_ENABLED !== 'false';
export const ORDER_EMAIL = process.env.VUE_APP_ORDER_EMAIL || 'geral@cm-tabuaco.pt';
